export const stripPlateHyphens = (plate: string | null | undefined): string => {
	if (!plate?.trim()) {
		return "";
	}

	return plate.trim().replace(/-/g, "");
};
